import { makeAutoObservable } from 'mobx'
import { LocationFactory, ContactFactory } from './../../shared/factories'
import UserProfileService from './../../shared/services/UserProfile.service'
import RestApi from './../../api/automation-api-client'

// const srvcEndpoint = '/bm10x/contacts'
// export default {
//   search: async (req, opts) => RestApi.request('GET', srvcEndpoint, req, opts),
//   get: async (id, req, opts) =>
//     RestApi.request('GET', srvcEndpoint, id, req, opts),
//   store: async (data, opts) =>
//     RestApi.request('POST', srvcEndpoint, data, opts),
//   update: async (id, data, opts) =>
//     RestApi.request('PUT', srvcEndpoint, id, data, opts),
//   delete: async (id, opts) => RestApi.request('DELETE', srvcEndpoint, id, opts),
// }

const isJson = (str) => {
  try {
    JSON.parse(str)
    return true
  } catch (ex) {
    return false
  }
}

const getContacts = async (locationId) => {
  try {
    return await ContactFactory.search({
      search: { location_id: locationId },
      pagination: false,
    })
  } catch (ex) {
    return []
  }
}

const searchContacts = async (locationId, searchTerm) => {
  try {
    return await ContactFactory.search({
      search: { location_id: locationId, global: `%${searchTerm}%` },
      pagination: false,
    })
  } catch (ex) {
    return []
  }
}

const getUserLocationIds = async () => {
  let locationIds
  try {
    locationIds = (
      (await UserProfileService.getUserMetas('10x---location-id')) || []
    ).shift()
  } catch (ex) {
    return {}
  }

  if (isJson(locationIds)) locationIds = JSON.parse(locationIds)

  locationIds =
    locationIds && typeof locationIds === 'object' ? locationIds : null
  if (locationIds && locationIds?.meta_value) {
    if (
      typeof locationIds?.meta_value === 'string' &&
      isJson(locationIds?.meta_value)
    )
      return JSON.parse(locationIds.meta_value)
    if (typeof locationIds?.meta_value === 'object')
      return locationIds.meta_value
  }

  return {}
}

const getLocations = async (locationIds) => {
  const ids = (Array.isArray(locationIds) ? locationIds : []).filter((n) => !!n)
  if (ids.length) {
    try {
      return await LocationFactory.search({
        search: { id: locationIds },
        pagination: false,
      })
    } catch (ex) {
      console.log('err ', ex)
      return []
    }
  }
  return []
}

class CrmStore {
  Locations = []
  Location = null
  Contacts = []
  Contact = null
  isSearchingContacts = false
  myLocations = { recruiter: null, sales: null }
  isInitializing = false
  isInitialized = false
  isEditing = false
  isAssigned = false
  searchTerm = ''
  emptyResults = false

  getMyLocation = async () => {}

  setMyLocations = async () => {
    const { recruiter, sales } = await getUserLocationIds(),
      myLocationIds = [recruiter, sales].filter((n) => !!n),
      MyLocations = myLocationIds.length && (await getLocations(myLocationIds))

    this.Contact = null
    this.Contacts = []
    this.Locations = MyLocations
    this.myLocations = { recruiter, sales }
    this.isInitialized = true
  }

  setLocation = (Location, fetchContacts) => {
    return !!(this.Location = Location || null)
  }

  isLocationAuthenticated = async (locationId) => {
    if (!locationId) return
    return await RestApi.request(
      'GET',
      '/nova-vendor/bm10x-dashboard/bm10x/locations/me',
      {},
      {}
    )
  }

  initLocation = async (locationId) => {
    try {
      this.isLocationAuthenticated(locationId)
      // return await this.fetchContactsByLocation(locationId)
    } catch (ex) {
      return false
    }
  }

  fetchContactsByLocation = async (locationId) => {
    let Contacts = []
    if (locationId) {
      try {
        Contacts = await getContacts(locationId)
      } catch (ex) {}
    }

    this.Contacts = Contacts
    return Contacts
  }

  canEditContact = () => {
    return this.Contact === null
  }

  editContact = async (Contact) => {
    this.Contact = Contact
    this.isEditing = true
    this.isAssigned = false
  }

  createNewContact = async (locationId) => {
    this.editContact(
      await ContactFactory.create({
        location_id: locationId || this.Location?.id(),
      })
    )
  }

  assignContact = (Contact) => {
    if (!Contact || typeof Contact !== 'object') return this.resetContact()

    if ((this.Contact = Contact)) {
      if (
        this.Contacts.map((C) => parseInt(C.id())).indexOf(
          parseInt(Contact.id())
        ) > 0
      )
        this.Contacts.push(Contact)
    }

    this.isEditing = false
    this.isAssigned = true
    return Contact
  }

  resetContact = () => {
    this.Contact = null
    this.isAssigned = false
  }

  searchContacts = async (locationid, searchTerm) => {
    this.isSearchingContacts = true
    const Contacts = await searchContacts(locationid, searchTerm)
    this.isSearchingContacts = false
    this.emptyResults = !Contacts || !Contacts.length
    return (this.Contacts = Contacts)
  }

  fetchContactById = async (contactId) => {
    try {
      return this.assignContact(
        await ContactFactory.findById(contactId ? contactId : this.contactId)
      )
    } catch (ex) {
      console.error(`${ex}`)
    }
  }

  constructor() {
    makeAutoObservable(this)
  }

  init = async () => {
    if (this.isInitialized) return true

    this.isInitializing = true

    // try {
    //   // console.log(`locations ?? ${await this.setMyLocations()}`);
    // }
    // catch (ex) {
    //   console.log(`error >> ${ex}`);
    // }

    this.isInitializing = false
    this.isInitialized = true

    return true
  }
}

export default new CrmStore()
